import React from 'react';
import { Datagrid } from 'react-admin';

const FONT = "'Helvetica Neue', Helvetica, Arial, sans-serif";

// The redesign's table: rows alternating #F0F0F0 / white, bold 14px text with the first column in
// #222 and the rest in a lighter gray (#666 keeps 4.5:1 contrast on the gray rows), a plain bold
// header and rows that grow with multi-line cells.
const TABLE_SX = {
    '& .RaDatagrid-headerCell': {
        fontFamily: FONT,
        fontWeight: 700,
        fontSize: '14px',
        color: '#222',
        textTransform: 'none',
        backgroundColor: '#FFF',
        borderBottom: 'none',
    },
    '& .RaDatagrid-headerCell .MuiTableSortLabel-root, & .RaDatagrid-headerCell span': {font: 'inherit', color: 'inherit'},
    // Sortable columns always show a faint arrow (react-admin hides it until sorted), solid on the active one.
    '& .RaDatagrid-headerCell .MuiTableSortLabel-root .MuiTableSortLabel-icon': {display: 'inline-block', opacity: 0.35},
    '& .RaDatagrid-headerCell .MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon': {opacity: 1},
    '& .RaDatagrid-row': {height: '56px'},
    '& .RaDatagrid-rowEven': {backgroundColor: '#F0F0F0'},
    '& .RaDatagrid-rowOdd': {backgroundColor: '#FFF'},
    '& .RaDatagrid-rowCell': {
        fontFamily: FONT,
        fontWeight: 700,
        fontSize: '14px',
        color: '#666',
        borderBottom: 'none',
        verticalAlign: 'top',
        paddingTop: '16px',
        paddingBottom: '16px',
        whiteSpace: 'normal',
    },
    '& .RaDatagrid-rowCell span': {font: 'inherit', color: 'inherit'},
    '& .RaDatagrid-rowCell:first-of-type': {color: '#222'},
};

function CustomDatagrid({ sx = {}, ...props }) {
    return <Datagrid sx={{...TABLE_SX, ...sx}} {...props} />;
}

export default CustomDatagrid;
